import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store configuration for report categories
const reportCategoriesBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/report_categories",
  name: "ReportCategoriesStoreRefactor",
  objectName: "Rapportage Categorie", // Auto-generates CRUD success messages
  enableCache: true, // Enable caching since categories rarely change
  actionCableChannel: null, // No real-time updates needed
  infiniteLoading: false, // Simple list, no pagination needed
});

export const useReportCategoriesStoreRefactor = defineStore(
  "reportCategoriesRefactor",
  {
    ...reportCategoriesBaseStore,

    getters: {
      ...reportCategoriesBaseStore.getters,

      /**
       * Get all report categories (maps to state.data for compatibility)
       */
      reportCategories: (state) => {
        return state.data || [];
      },

      /**
       * Get report category by ID
       */
      getCategoryById: (state) => (id) => {
        return state.data.find((category) => category.id == id);
      },

      /**
       * Get active report categories only (if categories have an active field)
       */
      activeReportCategories: (state) => {
        return state.data.filter((category) => category.active !== false);
      },
    },

    actions: {
      ...reportCategoriesBaseStore.actions,

      // All methods including CRUD operations are fully inherited from base store
      // Auto-generated messages use "Rapportage Categorie" from objectName
    },
  },
);
